import { Component, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';

@Component({
  selector: 'app-site-list-page',
  templateUrl: './site-list-page.component.html',
  styleUrls: ['./site-list-page.component.scss'],
})
export class SiteListPageComponent {
  @ViewChild(MatAccordion) accordion: MatAccordion;
}
